// extracted by mini-css-extract-plugin
module.exports = {"index":"language-select_index_1G5tP","check":"language-select_check_3dpmB"};